export const TWO_DAYS_DELIVERY_LABEL = '2-Day Delivery';
export const ONE_DAY_DELIVERY_LABEL = '1-Day Delivery';
